export const MV_TYPOGRAPHY_LINE_HEIGHT = 1.45

export const SIZE_VARIANT = {
  DISPLAY_XL: { fontSize: 30, fontWeight: 800 },
  DISPLAY_LG: { fontSize: 25, fontWeight: 800 },
  DISPLAY_MD: { fontSize: 24, fontWeight: 800 },
  DISPLAY_SM: { fontSize: 22, fontWeight: 800 },
  TITLE_XL: { fontSize: 20, fontWeight: 800 },
  TITLE_LG: { fontSize: 18, fontWeight: 800 },
  TITLE_MD: { fontSize: 15.5, fontWeight: 800 },
  TITLE_SM: { fontSize: 15, fontWeight: 800 },
  TITLE_XS: { fontSize: 14, fontWeight: 700 },
  SUBTITLE_LG: { fontSize: 14.5, fontWeight: 600 },
  SUBTITLE_MD: { fontSize: 13.5, fontWeight: 600 },
  SUBTITLE_SM: { fontSize: 12.5, fontWeight: 600 },
  SUBTITLE_XS: { fontSize: 11.5, fontWeight: 500 },
  BODY_LG_NORMAL: { fontSize: 14, fontWeight: 400 },
  BODY_MD_NORMAL: { fontSize: 13.5, fontWeight: 400 },
  BODY_SM_NORMAL: { fontSize: 12.5, fontWeight: 400 },
  BODY_XS_NORMAL: { fontSize: 11.5, fontWeight: 400 },
  BODY_LG_BOLDEST: { fontSize: 14, fontWeight: 700 },
  BODY_MD_BOLDEST: { fontSize: 13.5, fontWeight: 700 },
  BODY_SM_BOLDEST: { fontSize: 12.5, fontWeight: 700 },
  BODY_XS_BOLDEST: { fontSize: 11.5, fontWeight: 700 },
  LABEL_LG_NORMAL: { fontSize: 13.5, fontWeight: 400 },
  LABEL_MD_NORMAL: { fontSize: 12.5, fontWeight: 400 },
  LABEL_SM_NORMAL: { fontSize: 11.5, fontWeight: 400 },
  LABEL_XS_NORMAL: { fontSize: 10.5, fontWeight: 400 },
  LABEL_LG_BOLDEST: { fontSize: 13.5, fontWeight: 700 },
  LABEL_MD_BOLDEST: { fontSize: 12.5, fontWeight: 700 },
  LABEL_SM_BOLDEST: { fontSize: 11.5, fontWeight: 700 },
  LABEL_XS_BOLDEST: { fontSize: 10.5, fontWeight: 700 },
  HELPER_TEXT_LG: { fontSize: 12.5, fontWeight: 400 },
  HELPER_TEXT_MD: { fontSize: 11.5, fontWeight: 400 },
  HELPER_TEXT_SM: { fontSize: 10.5, fontWeight: 400 },
  HELPER_TEXT_XS: { fontSize: 9.5, fontWeight: 400 },
  HELPER_TEXT_SM_BOLDEST: { fontSize: 10.5, fontWeight: 700 },
  HELPER_TEXT_XS_BOLDEST: { fontSize: 9.5, fontWeight: 700 },
  TABLE_HEADER: {
    fontSize: 11,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  }
}
